module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('SgsRenderNotificationSuccess', {
    model: {
      value: (_vm.notificationSuccess),
      callback: function($$v) {
        _vm.notificationSuccess = $$v
      },
      expression: "notificationSuccess"
    }
  }), _vm._v(" "), _c('SgsRenderNotificationError', {
    model: {
      value: (_vm.notificationError),
      callback: function($$v) {
        _vm.notificationError = $$v
      },
      expression: "notificationError"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-table', {
    staticClass: "margin-bottom-15",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.localDataTable,
      "stripe": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [(_vm.attr.multipleSelect) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.attr.actions.length > 0) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('actions'),
      "width": _vm.widthIcons
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.attr.actions.length > 0) ? _c('td', {
          attrs: {
            "data-th": _vm.$t('actions')
          }
        }, _vm._l((_vm.attr.actions), function(button) {
          return _c('el-button', {
            style: (_vm.returnBackgroundColor(button.backgroundColor)),
            attrs: {
              "size": "mini",
              "title": _vm.getButtonHint(button)
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.actionButton(button, _vm.row)
              }
            }
          }, [_c('i', {
            class: _vm.renderIcon(button.icon)
          })])
        }), 1) : _vm._e()]
      }
    }], null, false, 3650089197)
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getHeaders), function(header) {
    return _c('el-table-column', {
      attrs: {
        "label": _vm.getHeader(header),
        "prop": header.value
      }
    })
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23fdd560!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderGrid.vue
// module id = 897
// module chunks = 2